import BaseService from "./geral/BaseService";

const base = "AgendCntrDepot";

export default class UnidadesLiberadasArmadorService extends BaseService{
    
    constructor(props){
        super(props)
    }

    ListarArmadores = () => {
        return super.httpGet(`/${base}/ListarArmadoresComGrupos`);
    }

    ListarTiposCntr = () => {
        return super.httpGet(`/${base}/ListarTiposCntr`);
    }
    
    ListarUnidadesLiberadasPorArmador = (armId) => {
        if(armId)
            return super.httpGet(`/${base}/ListarUnidadesLiberadasPorArmador?armId=${armId}`);
        else
            return super.httpGet(`/${base}/ListarUnidadesLiberadas`);
    }

    SalvarUnidadesLiberadasArmador = (listaDefault) => {
        return super.httpPost(`/${base}/LiberarUnidadesArmadores`, listaDefault);
    }

    ExcluirUnidadesArmadorDepot = (id) => {
        return super.httpGet(`/${base}/ExcluirUnidadesArmador?id=${id}`);
    }

}


// WEBPACK FOOTER //
// ./src/services/UnidadesLiberadasArmadorService.js